module.exports = __webpack_public_path__ + "img/consume-icon.f9d85e69.png";